module.exports = __webpack_public_path__ + "static/media/temp_w_domu_grzanie_3.0de44120.svg";